export default "__VITE_ASSET__T8nZfKNa__"